// Rules for Wanted requests. The database enforces the same rules
// (sql/2026-11-03-wanted-and-contact-flags.sql) so they can't be got round.
import { CATEGORIES } from './constants'

// Not allowed for now: Trailers & Caravans, Medical & Mobility
export const WANTED_BLOCKED_CATEGORY_IDS = [27, 23]
export const WANTED_CATEGORIES = CATEGORIES.filter(c => !WANTED_BLOCKED_CATEGORY_IDS.includes(c.id))

// Cars, Bikes & Trucks stays (bicycles, e-bikes…) but registered vehicles don't
export const VEHICLE_CATEGORY_ID = 9
const VEHICLE_RE = /\b(car|cars|ute|utes|van|vans|truck|trucks|motorbike|motorbikes|motorcycle|motorcycles|moped|mopeds|rego|registered|sedan|hatchback|wagon|suv|4x4|tipper|bus|campervan|motorhome)\b/i
export const looksLikeRegisteredVehicle = (title, categoryId) =>
  Number(categoryId) === VEHICLE_CATEGORY_ID && VEHICLE_RE.test(String(title || ''))

export const WANTED_MAX_OPEN = 5
export const WANTED_EXPIRY_DAYS = 30

// Public Wanted cards show the first name only, never the surname.
// "Leigh Smith" → "Leigh", "leigh smith" → "Leigh", "MRS JANE DOE" → "Jane",
// "Dr. Sam Lee" → "Sam", "HireIt" → "HireIt"; blank, emails, numbers → "Someone"
const TITLES = /^(mr|mrs|ms|miss|mx|dr|prof|sir)\.?$/i
export const wantedFirstName = (fullName) => {
  const words = String(fullName || '').trim().split(/\s+/).filter(Boolean)
  while (words.length > 1 && TITLES.test(words[0])) words.shift()
  let first = (words[0] || '').replace(/^[^\p{L}]+|[^\p{L}]+$/gu, '')
  if (!first || !/\p{L}/u.test(first) || String(fullName).includes('@')) return 'Someone'
  const all = String(fullName)
  if (first === first.toLowerCase() || (all === all.toUpperCase() && all.replace(/[^\p{L}]/gu, '').length > 3)) {
    first = first.charAt(0).toUpperCase() + first.slice(1).toLowerCase()
  }
  return first.charAt(0).toUpperCase() + first.slice(1)
}

// Database error → plain English
export function describeWantedError(error) {
  const msg = String(error?.message || '')
  if (msg.includes('blocked_category')) return "Sorry, requests for that category aren't allowed on HireIt yet."
  if (msg.includes('blocked_vehicle')) return "Sorry, registered vehicles (cars, utes, vans, trucks, motorbikes) can't be requested on HireIt yet. Bicycles and e-bikes are fine."
  if (msg.includes('contact_details')) return 'Please remove the phone number or email before posting. People can message you through HireIt.'
  if (msg.includes('too_many_open')) return `You already have ${WANTED_MAX_OPEN} open requests. Mark one as "Found it" before posting another.`
  return msg || 'Something went wrong. Please try again.'
}
